import {
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import { Layout } from "./components/Layout";
import { Dashboard } from "./routes/index";
import { Settings } from "./routes/settings";
import { Transactions } from "./routes/transactions";
import { Review } from "./routes/review";
import { Patterns } from "./routes/patterns";
import { Fire } from "./routes/fire";
import { Investments } from "./routes/investments";
import { Digest } from "./routes/digest";

const rootRoute = createRootRoute({ component: Layout });

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: Dashboard,
});

const transactionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/transactions",
  component: Transactions,
});

const reviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/review",
  component: Review,
});

const patternsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/patterns",
  component: Patterns,
});

const fireRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/fire",
  component: Fire,
});

const investmentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/investments",
  component: Investments,
});

const digestRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/digest",
  component: Digest,
});

const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings",
  component: Settings,
});

const routeTree = rootRoute.addChildren([
  dashboardRoute,
  transactionsRoute,
  reviewRoute,
  patternsRoute,
  fireRoute,
  investmentsRoute,
  digestRoute,
  settingsRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
